@if (isBackofficeAccount) {
    <app-backoffice-management></app-backoffice-management>
} @else {
    <app-customer-management></app-customer-management>
}
